import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const RetmCallback = () => {
  const { t } = useTranslation("integrations");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [countdown, setCountdown] = useState(5);

  const status = searchParams.get("status");
  const businessId = searchParams.get("business_id");
  const errorMessage = searchParams.get("message");

  const isSuccess = status === "success";

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/integrations/retm");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <Stack
      gap={3}
      p={{ xs: 2, sm: "8px 32px 32px 32px" }}
      alignItems="center"
      justifyContent="center"
      minHeight="60vh"
    >
      <Card
        variant="outlined"
        sx={{
          borderRadius: "16px",
          maxWidth: 480,
          width: "100%",
        }}
      >
        <CardContent>
          <Stack spacing={3} alignItems="center" py={4} px={2}>
            {/* Icon */}
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              width={80}
              height={80}
              borderRadius="50%"
              bgcolor={isSuccess ? "#ECFDF3" : "#FEF3F2"}
            >
              {isSuccess ? (
                <CheckCircleIcon sx={{ fontSize: 48, color: "#12B76A" }} />
              ) : (
                <ErrorIcon sx={{ fontSize: 48, color: "#F04438" }} />
              )}
            </Box>

            {/* Title */}
            <Typography
              fontSize={24}
              fontWeight={600}
              color={isSuccess ? "#12B76A" : "#F04438"}
              textAlign="center"
            >
              {isSuccess ? t("callback.success") : t("callback.error")}
            </Typography>

            {/* Message */}
            <Typography fontSize={14} color="#667085" textAlign="center">
              {isSuccess
                ? t("callback.successMessage")
                : errorMessage || t("callback.errorMessage")}
            </Typography>

            {/* Business ID (on success) */}
            {isSuccess && businessId && (
              <Box
                bgcolor="#F9FAFB"
                borderRadius="8px"
                p={2}
                width="100%"
                border="1px solid #EAECF0"
              >
                <Typography fontSize={12} color="#667085" textAlign="center">
                  {t("retm.businessId")}
                </Typography>
                <Typography
                  fontSize={16}
                  fontWeight={600}
                  color="#344054"
                  textAlign="center"
                >
                  {businessId}
                </Typography>
              </Box>
            )}

            {/* Redirect Info */}
            <Stack spacing={1} alignItems="center">
              <Typography fontSize={12} color="#98A2B3">
                {t("callback.redirecting")}
              </Typography>
              <Box display="flex" alignItems="center" gap={1}>
                <CircularProgress size={16} />
                <Typography fontSize={14} color="#667085">
                  {countdown}s
                </Typography>
              </Box>
            </Stack>

            {/* Manual Navigation Button */}
            <Button
              variant="contained"
              onClick={() => navigate("/integrations/retm")}
              fullWidth
            >
              {isSuccess ? t("actions.manageMappings") : t("actions.reconnect")}
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default RetmCallback;
